export const FETCH_START = 'fetchStartCatalogues'
export const FETCH_END = 'fetchEndCatalogues'
export const SET_CATALOGUES = 'setCatalogues'
export const SET_TOTAL_CATALOGUES = 'setTotalCatalogues'